import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { CustomTranslateLoader } from '@core/i18n/custom-translate-loader';
import {
  FaroErrorHandler,
  FaroRouterService,
  initializeFaroMonitoring,
} from '@core/monitoring';
import { ConfigService } from '@core/services/config.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideStore } from '@ngxs/store';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { ErrorState } from '@shared/state/error.state';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore([ErrorState]),
    // First, load the config
    provideAppInitializer(async () => {
      const configService = inject(ConfigService);
      await configService.loadConfig();

      // Initialize Faro immediately after config is loaded
      const enabled = configService.get('faroEnabled') === 'true';
      const collectorUrl = configService.get('faroCollectorUrl');

      console.log('Faro config:', { enabled, collectorUrl });

      if (!enabled || !collectorUrl) {
        console.log('Faro monitoring is disabled or not configured');
        return;
      }

      initializeFaroMonitoring({
        collectorUrl,
        appName: configService.get('faroAppName') || 'answer-module-client',
        appVersion: configService.get('faroAppVersion') || '1.0.0',
        environment: configService.get('faroEnvironment') || 'development',
      });

      console.log('Faro monitoring initialized successfully');
    }),
    // Initialize router monitoring after Faro is ready
    provideAppInitializer(() => {
      const faroRouterService = inject(FaroRouterService);
      faroRouterService.initialize();
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    // Custom error handler using Faro (from official docs)
    { provide: ErrorHandler, useClass: FaroErrorHandler },
    provideToastr({
      toastComponent: ToastComponent,
      timeOut: 3000,
      positionClass: 'inline',
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
        },
      }),
    ),
  ],
};
